export default __webpack_public_path__ + "static/media/placeholder-firstServe-featured.a802ce7b.svg";